import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
// import { TopBanner } from "../../common/TopBanner";

export const search_campaign_tdf = type => {
  return (
    <div className="container">
      {breadcrumbs(type, [
        { text: "キャンペーン - 市区町村の選択" },
      ])}

      <div className="search_campaign_tdf">
        <div id="searchArea">
          <div id="campaign_city">
            <h2 className="search_campaign">お得なキャンペーン</h2>
            <div className="supersale">
              <h3 className="search_campaign1">
                好評につき期間継続して <span>スーパーセール実施中!!</span>
              </h3>
            </div>
            <div className="medamaCp">
              <h3 className="search_campaign2">
                大好評につき実施継続中! <span>目玉部屋キャンペーン</span>
              </h3>
            </div>
          </div>

          <form
            action="/hokkaido/search_campaign/list/"
            name="search_city"
            method="get"
          >
            <h2 className="mt15">キャンペーン検索（市区町村の選択）</h2>

            <div className="sentakukirikae">
              <div className="kensuText">
                <p>
                  お探しの市区町村を選択してください。
                  <br />
                  <span className="fc04">※</span>
                  （）内は、キャンペーン中のトランクルームの
                  <br />
                  件数になります。
                  <br />
                  <span className="fc04">※</span>
                  市区町村は5件まで選択できます。
                </p>
              </div>

              <div className="radioBtn">
                <ul>
                  <li>
                    <a
                      href="javascript:void(0)"
                      onclick="chgContract(''); return false;"
                    >
                      <img
                        src="resource/img/static/search_campaign_tdf/radioBtn_all_f2.jpg"
                        width="125"
                        height="40"
                        alt="全て"
                        className="imgsearchover"
                        id="chg0"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      onclick="chgContract('01'); return false;"
                    >
                      <img
                        src="resource/img/static/search_campaign_tdf/radioBtn_okunai.jpg"
                        width="125"
                        height="40"
                        alt="屋内型"
                        className="imgsearchover"
                        id="chg1"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      onclick="chgContract('02'); return false;"
                    >
                      <img
                        src="resource/img/static/search_campaign_tdf/radioBtn_okugai.jpg"
                        width="125"
                        height="40"
                        alt="屋外型"
                        className="imgsearchover"
                        id="chg2"
                      />
                    </a>
                  </li>

                  <li>
                    <a
                      href="javascript:void(0)"
                      onclick="chgContract('99'); return false;"
                    >
                      <img
                        src="resource/img/static/search_campaign_tdf/radioBtn_bike.jpg"
                        width="125"
                        height="40"
                        alt="バイク"
                        className="imgsearchover"
                        id="chg3"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <ul className="areaList clearfix" id="ajaxArea">
              <li>
                <input
                  type="checkbox"
                  name="city[]"
                  value="札幌市厚別区"
                  onclick="limitCheckCity()"
                  id="city0"
                />
                <label for="city0">
                  <a href="#">札幌市厚別区（1）</a>
                </label>
              </li>
              <li>
                <input
                  type="checkbox"
                  name="city[]"
                  value="札幌市手稲区"
                  onclick="limitCheckCity()"
                  id="city1"
                />
                <label for="city1">
                  <a href="#">札幌市手稲区（1）</a>
                </label>
              </li>
              <li>
                <input
                  type="checkbox"
                  name="city[]"
                  value="札幌市豊平区"
                  onclick="limitCheckCity()"
                  id="city2"
                />
                <label for="city2">
                  <a href="#">札幌市豊平区（3）</a>
                </label>
              </li>
              <li>
                <input
                  type="checkbox"
                  name="city[]"
                  value="札幌市西区"
                  onclick="limitCheckCity()"
                  id="city3"
                />
                <label for="city3">
                  <a href="#">札幌市西区（2）</a>
                </label>
              </li>
              <li>
                <input
                  type="checkbox"
                  name="city[]"
                  value="札幌市東区"
                  onclick="limitCheckCity()"
                  id="city4"
                />
                <label for="city4">
                  <a href="#">札幌市東区（4）</a>
                </label>
              </li>
              <li>
                <input
                  type="checkbox"
                  name="city[]"
                  value="札幌市南区"
                  onclick="limitCheckCity()"
                  id="city5"
                />
                <label for="city5">
                  <a href="#">札幌市南区（1）</a>
                </label>
              </li>
            </ul>
            <p id="saBtn">
              <input
                type="image"
                src="resource/img/static/search_campaign_tdf/search2.gif"
                name=""
                value=""
                alt="この条件で検索する"
                id="submit_on"
              />
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/search_campaign_tdf.jsx